import type { GroupDetail } from 'models';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
export const canViewAnnouncements = ({ group }: { group: GroupDetail }) => group.settings?.allowPosts;
